import { all, fork, call, put, select, takeLatest, race, take, delay } from 'redux-saga/effects'
import moment from 'moment-timezone'
import api from 'lib/api/client'
import Actions, {
  startInit,
  finishInit,
  receiveLocations
} from 'reports/planningProducts/actions'
import heartbeat from 'lib/saga/heartbeat'
import {
  selectToken,
  selectTimezone,
  selectVisibleLocationIds
} from 'reports/planningProducts/selectors'
import { SET_NAVIGATION, setNavigationDate, configureNavigation } from 'containers/Navigation/actions'
import { selectNavigationRange } from 'containers/Navigation/selectors'
import { TYPE_WEEK_MONTH_DAY_SHIFT } from 'containers/Navigation/const'

function * init () {
  const token = yield select(selectToken)
  const timezone = yield select(selectTimezone)

  yield put(startInit())

  yield put(configureNavigation(TYPE_WEEK_MONTH_DAY_SHIFT))
  yield put(setNavigationDate(moment.tz({ hour: 0 }, timezone)))

  const [locations] = yield all([
    call(api.get, '/locations', { token }),
  ])

  yield all([
    put(receiveLocations(locations)),
  ])

  yield put(finishInit())
}

export default function * root () {
  if (process.env.NODE_ENV === 'development') {
    yield fork(heartbeat, 'Reports:planningProducts')
  }

  yield call(init)
}
